import type { User } from "firebase/auth"
import { createContext, type FC, type ReactNode, useEffect, useState } from "react"

import { LoadingSpinner } from "@/components/LoadingSpinner"

import { auth } from "./firebase"

export type CurrentUser = User

export const CurrentUserContext = createContext<CurrentUser | null>(null)

interface Props {
  children?: ReactNode
}

export const CurrentUserProvider: FC<Props> = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>()

  useEffect(() => auth.onAuthStateChanged(setCurrentUser), [currentUser])

  if (currentUser === undefined) {
    return (
      <div className="h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  return <CurrentUserContext.Provider value={currentUser}>{children}</CurrentUserContext.Provider>
}
